import classNames from 'classnames';
import { useTranslations } from 'next-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCrown } from '@fortawesome/pro-solid-svg-icons';
import { appRoutes } from 'config';
import { CtaButton } from './components/CtaButton';

const featureKeys = ['f1', 'f2', 'f3', 'f4', 'f5', 'f6'] as const;

export const Section16 = () => {
  const t = useTranslations();
  return (
    <section className={styles.section} id="pro">
      <div className={styles.wrap}>
        <div className={styles.card}>
          {/* left */}
          <div className={styles.left.container}>
            <span className={styles.left.tag}>
              ♦ {t('pages.home.section16.tag')}
            </span>
            <h2 className={styles.left.title}>
              <FontAwesomeIcon icon={faCrown} className={styles.left.crown} />
              MindFeed Pro
            </h2>
            <p className={styles.left.subtitle}>
              {t('pages.home.section16.subtitle')}
            </p>
            <div className={styles.left.buttons}>
              <CtaButton
                variant="gold"
                href={appRoutes.LOGIN}
                reportLocation="Homepage Pro"
              >
                {t('pages.home.section16.ctaTrial')}
              </CtaButton>
              <CtaButton
                variant="outline"
                href={appRoutes.PRICING.INDIVIDUAL}
                reportLocation="Homepage Pro"
              >
                {t('pages.home.section16.ctaCompare')}
              </CtaButton>
            </div>
          </div>

          {/* right */}
          <div className={styles.right.container}>
            <ul className={styles.right.list}>
              {featureKeys.map((key) => (
                <li key={key} className={styles.right.item}>
                  <span className={styles.right.check}>
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#fff"
                      strokeWidth={2.6}
                    >
                      <path d="M5 13l4 4L19 7" />
                    </svg>
                  </span>
                  {t(`pages.home.section16.${key}`)}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

const styles = {
  // scroll-mt offsets the #pro anchor for the fixed header stack
  // (announcement bar 36px + nav 64px) so it doesn't land under the header.
  section: 'marketing-dark:bg-mf-navy py-[70px] scroll-mt-[110px]',
  wrap: 'max-w-[1200px] mx-auto px-6 lg:px-10',
  card: classNames(
    'relative grid grid-cols-1 items-center gap-8 overflow-hidden rounded-[28px] px-[34px] py-10',
    'bg-[linear-gradient(118deg,#2447c4_0%,#5b34b0_46%,#b14a8f_100%)]',
    'shadow-[0_20px_50px_rgba(40,30,120,0.2)]',
    'marketing-dark:shadow-[0_40px_90px_rgba(40,30,120,0.4)]',
    'lg:grid-cols-2 lg:gap-12 lg:px-14 lg:py-[52px]',
    // decorative top-right circle
    'after:pointer-events-none after:absolute after:top-[-140px] after:right-[-80px]',
    'after:h-[360px] after:w-[360px] after:rounded-full after:bg-white/[0.08] after:content-[""]',
  ),
  left: {
    container: 'relative z-[2]',
    tag: classNames(
      'mb-[18px] inline-flex items-center gap-[7px] rounded-full bg-white/15 px-[13px] py-[7px]',
      'text-[11px] font-bold uppercase tracking-[0.14em] text-white',
    ),
    title:
      'flex items-center gap-3 text-[32px] font-extrabold leading-[1.08] tracking-[-0.02em] text-white sm:text-[38px]',
    crown: 'h-[34px] w-[34px] flex-shrink-0 text-[#ffa42e]',
    subtitle:
      'my-[14px] mb-7 max-w-[380px] text-[17px] leading-[1.6] text-white/85',
    buttons: 'flex flex-wrap gap-3',
  },
  right: {
    container: 'relative z-[2]',
    list: 'grid gap-[14px]',
    item: 'flex items-start gap-3 text-[15.5px] font-medium leading-[1.4] text-white',
    check: classNames(
      'mt-px flex h-[22px] w-[22px] flex-shrink-0 items-center justify-center rounded-full bg-white/20',
      '[&>svg]:h-[13px] [&>svg]:w-[13px]',
    ),
  },
};
